<template>
  <GroupItemCard :imgBackground="imgBackground" @openItem="goToLink">
    <template #img>
      <LinkIcon class="link__icon" size="24" />
    </template>
    <template #content>
      <GroupItemCardContent>
        <template #top-line>
          <p class="link__url">{{ item.link_url }}</p>
        </template>
        <template #mid-line>
          <p class="link__name">{{ item.name }}</p>
        </template>
        <template #bot-line>
          <p>{{ item.description }}</p>
        </template>
      </GroupItemCardContent>
    </template>
    <template #button>
      <LinkIcon :size="linkIconSize" />
    </template>
  </GroupItemCard>
</template>

<script>
import { LinkIcon } from 'vue-feather-icons'
import { GroupItemCard, GroupItemCardContent } from '.'

export default {
  name: 'LinkItemCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    GroupItemCard,
    GroupItemCardContent,
    LinkIcon,
  },
  inject: ['getBreakpoint'],
  computed: {
    imgBackground() {
      const image = this.item.logo_image_url
      const styleJson = {}

      if (image) styleJson.backgroundImage = `url(${image})`
      else
        styleJson.background =
          'linear-gradient(89.99deg, #BA93E1 3.58%, #3D24A5 97.14%)'

      return styleJson
    },
    linkIconSize() {
      const breakpoint = this.getBreakpoint()

      switch (breakpoint) {
        case 'mobile':
          return '16'

        case 'tablet':
          return '20'

        default:
          return '24'
      }
    },
  },
  methods: {
    goToLink() {
      window.open(this.item.link_url, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  width: 200px;
  margin: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.link {
  &__icon {
    margin-top: 42px;

    @include desktop {
      margin-top: 25px;
    }
  }
  &__url {
    text-transform: uppercase;
    white-space: nowrap;
  }
}
</style>
